export default __webpack_public_path__ + "static/media/NotoSans-SemiBold.a75c33f6.ttf";